<mat-card class="map-container">
  <div id="chart" class="chart-container bar"></div>
</mat-card>

